window.addEventListener('load', function () {
    const shownCount = 3;

    document.querySelectorAll('.results-div').forEach((resultsDiv) => {
        let noOfResults = resultsDiv.querySelectorAll('.result');
        let showMoreDiv = resultsDiv.nextElementSibling;
        if (noOfResults.length > shownCount)  {
            let hideStarting = shownCount + 1;
            resultsDiv.querySelectorAll('.result:nth-of-type(n+' + hideStarting + ')').forEach((result) =>{
                result.classList.add('hidden');
            });
        } else if (noOfResults.length <= shownCount) {
            showMoreDiv.classList.add('hidden');
        }

        showMoreDiv.addEventListener('click', () => {
            let toShowStarting = resultsDiv.querySelectorAll('.result:not(.hidden)').length + 1;
            let toShowEnding = toShowStarting + shownCount - 1;

            resultsDiv.querySelectorAll('.result:nth-child(n+' + toShowStarting +').result:nth-child(-n+' + toShowEnding + ')').forEach((result) =>{
                result.classList.remove('hidden');
            });

            let hidden = resultsDiv.querySelectorAll('.result.hidden');
            if (hidden.length === 0) {
                showMoreDiv.classList.add('hidden');
            }

        });
    });
});